require('./bootstrap');
window.Vue = require('vue').default;

import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        isModalShow: false,
        currentModal: null,
        modalProps: null,
        isAuth: false,
        customer: null,
        seasonTicketsGroups: [],
        captchaKey: null,
        isLoading: false,
        isShowPopup: false,
        popupProps: null,
        currentPopup: null,
        isMenuShow: false,
        insta: null,
        phone1: null,
        phone2: null,
        currentTradePoint: null,
        tradePoints: [],
        map: null,
        scheduleWeekdays: null,
        scheduleWeekends: null,
    },
    mutations: {
        updateScheduleWeekends(state, value) {
            state.scheduleWeekends = value;
        },
        updateScheduleWeekdays(state, value) {
            state.scheduleWeekdays = value;
        },
        updateMap(state, value) {
            state.map = value;
        },
        updateTradePoints(state, value) {
            state.tradePoints = value;
        },
        updateCurrentTradePoint(state, value) {
            state.currentTradePoint = value;
        },
        updatePhone2(state, value) {
            state.phone2 = value;
        },
        updatePhone1(state, value) {
            state.phone1 = value;
        },
        updateInsta(state, value) {
            state.insta = value;
        },
        updateIsMenuShow(state, value) {
            state.isMenuShow = value;
        },
        updateCurrentPopup(state, value) {
            state.currentPopup = value;
        },
        updatePopupProps(state, value) {
            state.popupProps = value;
        },
        updateIsShowPopup(state, value) {
            state.isShowPopup = value;
        },
        updateIsLoading(state, value) {
            state.isLoading = value;
        },
        updateCaptchaKey(state, value) {
            state.captchaKey = value;
        },
        updateSeasonTicketsGroups(state, value) {
            state.seasonTicketsGroups = value;
        },
        updateCustomer(state, value) {
            state.customer = value;
        },
        updateIsAuth(state, value) {
            state.isAuth = value;
        },
        updateModalProps(state, value) {
            state.modalProps = value;
        },
        updateCurrentModal(state, value) {
            state.currentModal = value;
        },
        updateIsModalShow(state, value) {
            state.isModalShow = value;
        },
    }
});

//modals
Vue.component('question-dialog', function (resolve) {
    require(['./components/modals/Question'], resolve)
});
Vue.component('service-buy-modal', function (resolve) {
    require(['./components/modals/ServiceBuyModal'], resolve)
});
Vue.component('modal-dialog', function (resolve) {
    require(['./components/modals/ModalDialog'], resolve)
});
Vue.component('add-prices-modal', function (resolve) {
    require(['./components/modals/AddPricesModal'], resolve)
});
Vue.component('up-balance-popup', function (resolve) {
    require(['./components/modals/account/UpBalance'], resolve)
});
Vue.component('account-modal', function (resolve) {
    require(['./components/modals/account/AccountModal'], resolve)
});
Vue.component('personal-info-tab', function (resolve) {
    require(['./components/modals/account/PersonalInfoTab'], resolve)
});
Vue.component('orders-tab', function (resolve) {
    require(['./components/modals/account/OrdersTab'], resolve)
});
Vue.component('visitings-tab', function (resolve) {
    require(['./components/modals/account/VisitingsTab'], resolve)
});
Vue.component('customer-card-tab', function (resolve) {
    require(['./components/modals/account/CustomerCardTab'], resolve)
});
Vue.component('recurring-subscriptions-tab', function (resolve) {
    require(['./components/modals/account/RecurringSubscriptionsTab'], resolve)
});
Vue.component('season-tickets-tab', function (resolve) {
    require(['./components/modals/account/SeasonTicketsTab'], resolve)
});
Vue.component('save-photo-modal', function (resolve) {
    require(['./components/modals/account/SavePhoto'], resolve)
});
Vue.component('login-modal', function (resolve) {
    require(['./components/modals/LoginModal'], resolve)
});
Vue.component('code-modal', function (resolve) {
    require(['./components/modals/CodeModal'], resolve)
});
Vue.component('select-trade-point-modal', function (resolve) {
    require(['./components/modals/SelectTradePointModal'], resolve)
});
Vue.component('loading', function (resolve) {
    require(['./components/modals/Loading'], resolve)
});
Vue.component('popup', function (resolve) {
    require(['./components/modals/Popup'], resolve)
});
Vue.component('message', function (resolve) {
    require(['./components/modals/Message'], resolve)
});
Vue.component('menu-modal', function (resolve) {
    require(['./components/modals/MenuModal'], resolve)
});
Vue.component('show-image-modal', function (resolve) {
    require(['./components/modals/ShowImage'], resolve)
});
//modals

//inputs
Vue.component('label-input', function (resolve) {
    require(['./components/inputs/LabelInput'], resolve)
});
Vue.component('state-input', function (resolve) {
    require(['./components/inputs/StateInput'], resolve)
});
Vue.component('phone-input', function (resolve) {
    require(['./components/inputs/PhoneInput'], resolve)
});
Vue.component('filter-input', function (resolve) {
    require(['./components/inputs/FilterInput'], resolve)
});
Vue.component('email-input', function (resolve) {
    require(['./components/inputs/EmailInput'], resolve)
});
//inputs

//sliders
Vue.component('gallery-slider', function (resolve) {
    require(['./components/sliders/GallerySlider'], resolve)
});
Vue.component('trainers-slider', function (resolve) {
    require(['./components/sliders/TrainersSlider'], resolve)
});
//sliders

Vue.component('prices', function (resolve) {
    require(['./components/Prices'], resolve)
});
Vue.component('schedule', function (resolve) {
    require(['./components/Schedule'], resolve)
});
Vue.component('app', function (resolve) {
    require(['./components/App'], resolve)
});

Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        }
        window.addEventListener('scroll', f)
    }
});

const app = new Vue({
    el: '#app',
    store,
});
